<template>
  <div>

    <v-container>

      <v-layout wrap>
        <v-flex xs6 md2 mr-5>
          <v-menu v-model="start_date_menu" :close-on-content-click="false" :nudge-right="40" full-width lazy offset-y min-width="290px">
            <v-text-field slot="activator" v-model="filter.start_date" label="Start date" prepend-icon="event" readonly></v-text-field>
            <v-date-picker v-model="filter.start_date" @input="start_date_menu = false" :max="filter.end_date"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md2 mr-5>
          <v-menu v-model="end_date_menu" :close-on-content-click="false" :nudge-right="40" full-width lazy offset-y min-width="290px">
            <v-text-field slot="activator" v-model="filter.end_date" label="End date" prepend-icon="event" readonly></v-text-field>
            <v-date-picker v-model="filter.end_date" @input="end_date_menu = false" :min="filter.start_date"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs12 md6>
          <v-select label="Call Type" v-model="filter.calltypes" :items="all_call_types" multiple small-chips></v-select>
        </v-flex>
      </v-layout>

      <!-- <v-layout align-center wrap>
        <v-flex xs6 md3>
          <v-checkbox v-model="filter.show_incoming" label="Incoming"></v-checkbox>
        </v-flex>
        <v-flex xs6 md3>
          <v-checkbox v-model="filter.show_incoming_missed" label="Missed Incoming"></v-checkbox>
        </v-flex>
        <v-flex xs6 md3>
          <v-checkbox v-model="filter.show_outgoing" label="Outgoing"></v-checkbox>
        </v-flex>
        <v-flex xs6 md3>
          <v-checkbox v-model="filter.show_outgoing_missed" label="Missed Outgoing"></v-checkbox>
        </v-flex>
      </v-layout> -->

      <v-layout justify-end row fill-height  align-center mt-3>
        <v-flex class="red--text body-1 font-italic">
          <div v-if="dateDiff > 7">
            Date range should not be more than 7 days.
          </div>
        </v-flex>
        <v-flex shrink>
          <v-btn color="primary" :disabled="dateDiff > 7" @click="applyFilter">
            Apply
          </v-btn>
        </v-flex>
      </v-layout>

    </v-container>

    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  name: 'cdrfilter',
  data: () => ({
    //start_date: new Date(2018,12,12).toISOString().substr(0,10),
    filter: {
      start_date: new Date().toISOString().substr(0,10),
      end_date: new Date().toISOString().substr(0,10),
      // show_incoming: true,
      // show_incoming_missed: true,
      // show_outgoing: true,
      // show_outgoing_missed: true,
      calltypes: [ 'incoming', 'missed-incoming', 'outgoing', 'missed-outgoing' ]
    },
    start_date_menu: false,
    end_date_menu: false,
    all_call_types: [ 'incoming', 'missed-incoming', 'outgoing', 'missed-outgoing' ]
  }),
  methods: {
    applyFilter: function () {
      this.$emit('apply_filter', this.filter)
    }
  },
  computed: {
    dateDiff: function () {
      let d1 = new Date(this.filter.end_date)
      let d2 = new Date(this.filter.start_date)
      return Math.ceil((d1 - d2) / (1000 * 3600 * 24))
    }
  },
  created: function() {
    var d = new Date()
    d.setDate(1)
    this.filter.start_date = d.toISOString().substr(0,10)
    d.setMonth(d.getMonth() + 1)
    d.setDate(0)
    this.filter.end_date = d.toISOString().substr(0,10)
  }
}
</script>

<style scoped>
</style>
